import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';
import { ACCEPT_JOIN_REQUEST_RESOURCE, JOIN_REQUESTS_RESOURCE } from '../../constants';

const AcceptJoinRequestService = ComposedComponent =>
  reduxFetch([
    {
      resource: ACCEPT_JOIN_REQUEST_RESOURCE,
      method: 'post',
      request: (orgId, id, body, callback, rejectCallback, t) => ({
        url: apiRoutes.acceptPrincipalJoinRequests(orgId, id),
        body,
        meta: {
          removeFromOtherList: {
            resource: JOIN_REQUESTS_RESOURCE,
            idProp: 'id',
            id,
          },
          callback,
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'acceptJoinRequestFailed'),
            onSuccessMessage: t('acceptJoinRequestSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default AcceptJoinRequestService;
